<template>
  <div class="num-range__box">
    <el-input-number v-model="min" @change="handleChange" :min="$attrs.min" :max="$attrs.max" v-bind="$attrs"></el-input-number>
    ~
    <el-input-number v-model="max" @change="handleChange" :min="$attrs.min" :max="$attrs.max" v-bind="$attrs"></el-input-number>
    <span v-if="showUnit">（{{unit}}）</span><span v-show="max>0 && showUnit">大于等于{{min}}{{unit}}，小于{{max}}{{unit}}</span>
  </div>
</template>

<script>
export default {
  name: 'yblNumRange',
  model: {
    prop: 'val',
    event: 'change'
  },
  props: {
    val: {
      type: Array | String,
      default: () => [0, 0]
    },
    showUnit: { // 是否显示单位
      type: Boolean,
      default: () => false
    },
    unit: { // 单位值
      type: String,
      default: () => '万元'
    }
  },
  data () {
    return {
      min: '',
      max: ''
    }
  },
  created () {
    let temp = Array.isArray(this.val) ? this.val : (this.val && this.val.split(','))
    temp = temp || []
    this.min = (temp.length > 0 && temp[0]) || ''
    this.max = (temp.length > 1 && temp[1]) || ''
  },
  methods: {
    handleChange (value) {
      // console.log(value)
      // console.log(this.min, this.max)
      if (this.max < this.min) {
        this.max = this.min
      }
      this.$emit('change', [this.min, this.max])
    }
  },
  watch: {
    'val': function (newVal, oldVal) {
      if (this.val && this.val.length) {
        const val = Array.isArray(this.val) ? this.val : this.val.split(',')
        this.min = val[0]
        this.max = val[1]
      } else {
        this.min = ''
        this.max = ''
      }
    }
  }
}
</script>

<style lang="less">
.num-range__box{
  width: 200px;
  .el-input-number--small{
    width: 90px !important;
    .el-input{
      min-width: 90px !important;
      width: 90px !important;
    }
    .el-input__inner{
      padding-left: 30px;
      padding-right: 30px;
    }
    .el-input-number__decrease,
    .el-input-number__increase{
      width: 25px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Range.vue